import React, { useMemo } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

function LayerViewer({ files = [] }) {
  const { colors } = useTheme();
  const layers = Array.isArray(files) ? files : [];

  const styles = useMemo(() => StyleSheet.create({
    wrap: {
      width: '100%',
      borderRadius: 12,
      borderWidth: 1,
      borderColor: colors.border_color_secondary,
      backgroundColor: colors.solid_color_tertiary,
      padding: 12,
      gap: 10,
    },
    stack: {
      height: 190,
      borderRadius: 12,
      backgroundColor: colors.solid_color_block,
      overflow: 'hidden',
      position: 'relative',
    },
    image: {
      position: 'absolute',
      width: '78%',
      height: '78%',
      borderRadius: 10,
      borderWidth: 1,
      borderColor: colors.border_color_secondary,
      backgroundColor: colors.solid_color_secondary,
    },
    list: { gap: 6 },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingHorizontal: 8,
      paddingVertical: 6,
      borderRadius: 8,
      backgroundColor: colors.solid_color_block,
    },
  }), [colors]);

  return (
    <View style={styles.wrap}>
      <View style={styles.stack}>
        {layers.slice(0, 4).map((file, index) => {
          const url = file?.url || file?.path || file?.signedUrl || file?.cdnPath;
          const offset = index * 14;
          return url ? (
            <Image
              key={file.id || index}
              source={{ uri: url }}
              style={[styles.image, { left: offset + 10, top: offset + 10, opacity: 0.88 - (index * 0.12) }]}
            />
          ) : null;
        })}
      </View>
      <Text size='s' color='primary' weight='bold'>Layer output</Text>
      <View style={styles.list}>
        {layers.map((file, index) => (
          <View key={file.id || index} style={styles.row}>
            <Icon name='layer-group' size={13} color={colors.text_color_secondary} />
            <Text size='xs' color='secondary' numberOfLines={1}>
              {file?.originalName || file?.name || `Layer ${index + 1}`}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}

export default React.memo(LayerViewer);
